import { render } from "./why-us.vue?vue&type=template&id=8d5df554&scoped=true"
import script from "./why-us.vue?vue&type=script&lang=js"
export * from "./why-us.vue?vue&type=script&lang=js"

import "./why-us.vue?vue&type=style&index=0&id=8d5df554&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d5df554"]])

export default __exports__